import { useCallback } from 'react';
import { useTranslation } from '@/contexts/LanguageContext';
import { getLocalizedCountryName } from '@/lib/translations/countryNames';

/**
 * Hook for getting localized country names based on current language
 * @returns Object with getCountryName function
 */
export function useCountryName() {
  const { language } = useTranslation();

  const getCountryName = useCallback(
    (englishName: string): string => {
      return getLocalizedCountryName(englishName, language);
    },
    [language]
  );

  return { getCountryName };
}
